import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ZoneFormLayer from "../components/ZoneFormLayer";

const ZoneFormPage = () => {
  return (
    <MasterLayout>
      <ZoneFormLayer />
    </MasterLayout>
  );
};

export default ZoneFormPage;
